module.exports = __webpack_public_path__ + "img/5-4.d46a95be.svg";